<template>
	<div class="display_wrapper">

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="$router.go(-1)"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">Other Charge</v-toolbar-title>

		    <v-spacer></v-spacer>

		    <v-btn icon @click="fn_edit">
		    	<v-icon>edit</v-icon>
		    </v-btn>

		    <v-btn icon @click="fn_getBottomMenu">
		      <v-icon>more_vert</v-icon>
		    </v-btn>
		</v-toolbar>

		<div class="display hasToolbar">
			<div class="display_title">{{displayData.name}}</div>

			<v-list class="section-container" two-line>
		        <v-subheader light>Details</v-subheader>
		        <v-divider></v-divider>
		        <!-- <div>
		        	<v-list-tile>
			          	<v-list-tile-content>
			          		<v-list-tile-title>Short Name</v-list-tile-title>
			              	<v-list-tile-sub-title>{{displayData.shortName ? displayData.shortName : '-'}}</v-list-tile-sub-title>
			            </v-list-tile-content>
			        </v-list-tile>
			        <v-divider></v-divider>
		        </div> -->
		       	<div>
		       	 	<v-list-tile>
			          	<v-list-tile-content>
			          		<v-list-tile-title>Mode</v-list-tile-title>
			              	<v-list-tile-sub-title>{{displayData.mode ? 'Value' : 'Percentage'}}</v-list-tile-sub-title>
			            </v-list-tile-content>
			        </v-list-tile>
			        <v-divider></v-divider>
		       	</div>
		       	<div>
		       	 	<v-list-tile>
			          	<v-list-tile-content>
			          		<v-list-tile-title>Nature</v-list-tile-title>
			              	<v-list-tile-sub-title>{{displayData.nature ? '(-)' : '(+)'}}</v-list-tile-sub-title>
			            </v-list-tile-content>
			        </v-list-tile>
			        <v-divider></v-divider>
		       	</div>
		        <div>
		        	<v-list-tile>
		          		<v-list-tile-content>
		          			<v-list-tile-title>Adjust in Sale</v-list-tile-title>
		              		<v-list-tile-sub-title>{{displayData.adjustInSale ? 'Yes' : 'No'}}</v-list-tile-sub-title>
		            	</v-list-tile-content>
		        	</v-list-tile>
		        	<v-divider></v-divider>
		        </div>
		        <div v-if="!displayData.adjustInSale">
		       		<v-list-tile>
			          	<v-list-tile-content>
			          		<v-list-tile-title>Ledger</v-list-tile-title>
			              	<v-list-tile-sub-title>{{displayData.saleAccountItemName}}</v-list-tile-sub-title>
			            </v-list-tile-content>
			        </v-list-tile>
			        <v-divider></v-divider>
		       	</div>

		        <div>
		        	<v-list-tile>
		          		<v-list-tile-content>
		          			<v-list-tile-title>Adjust in Purchase</v-list-tile-title>
		              		<v-list-tile-sub-title>{{displayData.adjustInPurchase ? 'Yes' : 'No'}}</v-list-tile-sub-title>
		            	</v-list-tile-content>
		        	</v-list-tile>
		        	<v-divider></v-divider>
		        </div>
		        <div v-if="!displayData.adjustInPurchase">
		       		<v-list-tile>
			          	<v-list-tile-content>
			          		<v-list-tile-title>Ledger</v-list-tile-title>
			              	<v-list-tile-sub-title>{{displayData.purchaseAccountItemName}}</v-list-tile-sub-title>
			            </v-list-tile-content>
			        </v-list-tile>
		       	</div>

		    </v-list>
		</div>

		<dialog-confirmation ref="ref_dialogDeleteConfirmation" header="Delete Master?" :actionMethod="fn_deleteMaster" params="delete" :displayView='true'></dialog-confirmation>

	</div>
</template>

<script>
const menuItem = require('../../../../config.js').configs.menuItem;
import {masterMixin} from '../../master_mixin.js'
import dialogConfirmation from '../../../dialogs/dialog_confirmation'

	export default{
		mixins: [masterMixin],
		data(){
			return{
				displayData:{}
			}
		},
		components:{
			'dialog-confirmation': dialogConfirmation
		},
		methods:{
			fn_get: function(itemId){
				var self = this;
		  		this.getData('AddOns', itemId, 
					{
						onSuccess: function(response){
				          console.log(response);
				          self.displayData = JSON.parse(response);
				          self.displayData.shortName == 'null' ? self.displayData.shortName = null : '';
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},
			fn_showWebView: function () {
				var viewObject = {};
				viewObject.ToolbarTitle = "Other Charges";
				viewObject.TopMenu = [menuItem.edit];
				viewObject.isBottomMenu = true;

				var tagId = null;
				this.$route.params && this.$route.params.tagId ? tagId = this.$route.params.tagId : '';
				var self = this;

				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null, 
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			fn_getBottomMenu: function (tagId) {
				var bottomMenu = {"BottomMenu": [menuItem.copy]};
				!this.displayData.isSystem ? bottomMenu.BottomMenu.push(menuItem.delete) : '';

				this.setBottomMenu(tagId, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use
				if(menuAction=='edit' && this.displayData && this.displayData.addOnsId){
					this.fn_edit();
				}
				else if(menuAction=='copy'){
					this.$router.push({path:'/addons/othercharges/new', query:{tagId:this.guidWeb(), itemId:this.displayData.addOnsId, copy:true}});
				}
				else if(menuAction=='delete'){
					this.$refs['ref_dialogDeleteConfirmation'].dialog_confimation = true;
				}
			},

			fn_deleteMaster: function(){
				let self = this;
				this.$refs['ref_dialogDeleteConfirmation'].dialog_confimation = false;
				this.fn_deleteMasterItem('addOns', this.displayData.addOnsId, function(response){
					if(response){
                        self.showToast('Item deleted');
                        self.$router.go(-1);
                    }
                    else{
                        self.showToast("Item cannot be deleted as already in use");
                    }
				})
			},

			fn_edit: function () {
				this.$router.push("/addons/othercharges/"+this.displayData.addOnsId+"/edit");
			}
		},
		mounted: function(){
			this.fn_showWebView();

			window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;
	        
			if(this.$route.params && this.$route.params.tagId){
				this.fn_get(this.$route.params.tagId);
			}
		},
		beforeRouteLeave (to, from, next) {
			if(this.$refs['ref_dialogDeleteConfirmation'].dialog_confimation){
				this.$refs['ref_dialogDeleteConfirmation'].dialog_confimation = false;
				next(false);
			}
			else{
				next(true);
			}
	    }
	}

</script>


// WEBPACK FOOTER //
// src/components/masters/forms/other_charges/display.vue